export default __webpack_public_path__ + "static/media/gordita-light.aed22b1b.woff";